<template>
  <v-layout :id="id" style="height: 94%" />
</template>

<script>
import OpenSeadragon from 'openseadragon'
import { Overlay } from './../../helpers/PaperjsOverlay'
const paper = require('paper')

export default {
  name: 'OpenSeaDragonViewer',
  props: {
    id: {
      type: String,
      default: 'openseadragon-viewer'
    },
    options: {
      type: Object
    },
    i18n: {
      type: Object
    },
    currentPage: {
      type: Number,
      default: 0
    },
    messages: {
      type: Object,
      default: () => ({
        'Tooltips.FullPage': '',
        'Tooltips.Home': '',
        'Tooltips.ZoomIn': '',
        'Tooltips.ZoomOut': '',
        'Tooltips.NextPage': '',
        'Tooltips.PreviousPage': '',
        'Tooltips.RotateLeft': '',
        'Tooltips.RotateRight': '',
        'Errors.Dzc': '',
        'Errors.Dzi': '',
        'Errors.Xml': '',
        'Errors.ImageFormat': '',
        'Errors.Security': '',
        'Errors.Status': '',
        'Errors.OpenFailed': ''
      })
    },
    tileSources: {
      type: Array
    },
    polygonsData: {
      type: Array
    }
  },
  data: function() {
    return {
      viewer: null,
      debugMessage: '',
      componentKey: 0,
      overlay: null,
      path: null,
      tool: null,
      scope: null,
      segment: null,
      movePath: false,
      lastSelected: null,
      dragging: false,
      values: {
        paths: 1,
        minPoints: 4,
        maxPoints: 4,
        minRadius: 400,
        maxRadius: 400
      },
      hitOptions: {
        segments: true,
        stroke: true,
        fill: true,
        tolerance: 5
      }
    }
  },
  watch: {
    polygonsData: function() {
      this.importFromJSON(this.polygonsData)
    },
    currentPage: function(newVal, oldValue) {
      console.log('OSD currentPage tileSources', newVal, oldValue)
      if (this.viewer !== null) {
        this.viewer.goToPage(newVal)
      }
    },
    tileSources: function(newVal, oldValue) {
      console.log('OSD watch tileSources', newVal, oldValue)
      if (this.viewer !== null) {
        this.viewer.open(newVal)
      }
    }
  },
  created() {},
  mounted() {
    //console.log('MOUNTED')
    this.setup()
    paper.settings.handleSize = 8
  },
  updated() {
    //console.log('UPDATED')
    this.setup()
  },
  beforeDestroy: function() {
    console.log('OSD beforeDestroy')
    this.viewer.destroy()
    this.viewer = null
  },
  methods: {
    setup: function() {
      if (!this.viewer) {
        var self = this
        const _options = Object.assign({}, this.options)
        _options.id = this.id

        console.log('OSD setup', _options)
        this.viewer = OpenSeadragon(_options)

        //This is a ipad performance fix
        // this.viewer.addHandler("canvas-release", function(viewer) {
        //   document.getElementById("favorites").focus();
        // });
        // this.viewer.addHandler("canvas-pinch", function(viewer) {
        //   document.getElementById("favorites").focus();
        // });
        // this.viewer.addHandler("animation-finish", function(viewer) {
        //   document.getElementById("favorites").focus();
        // });
      }
      this.viewer.open(this.tileSources)
      this.viewer.gestureSettingsMouse.clickToZoom = false
      this.paperOverlayInit(this.viewer)

      // event listeners

      // this.overlay
      // 	.paperCanvas()
      // 	.addEventListener("mousedown", self.onMouseDown);
      // this.overlay.paperCanvas().addEventListener("mouseup", self.onMouseUp);
      // this.overlay
      // 	.paperCanvas()
      // 	.addEventListener("mousemove", self.onMouseMove);
      // this.overlay.paperCanvas().addEventListener("keypress", self.onKeyUp);

      new OpenSeadragon.MouseTracker({
        element: self.viewer.canvas,
        pressHandler: self.onMouseDown,
        dragHandler: self.doDrag,
        dragEndHandler: self.dragEndHandler,
        keyUpHandler: self.onKeyUp,
        releaseHandler: self.dragEndHandler
      }).setTracking(true)

      this.importFromJSON(this.polygonsData)

      //window.addEventListener("keypress", self.onKeyUp);
    },
    paperOverlayInit(viewer) {
      var self = this
      //paper = new paper.PaperScope();
      this.overlay = new Overlay(viewer)

      // paper.setup(this.overlay.paperCanvas());
      // this.tool = this.createTool(self.scope);

      OpenSeadragon.Viewer.prototype.paperjsOverlay = this.overlay

      // this._paperjsOverlayInfo = new Overlay(this);
      // return this._paperjsOverlayInfo;

      this.overlay.resize()
      this.overlay.resizecanvas()

      // paper = new paper.PaperScope();
      // paper.setup(this.overlay.paperCanvas());
      // this.tool = this.createTool(self.scope);
      //console.log("SCOPE: ", paper);
      //paper.view.draw();

      // new OpenSeadragon.MouseTracker({
      //   element: self.viewer.canvas,
      //   pressHandler: self.press_handler,
      //   dragHandler: self.drag_handler,
      //   dragEndHandler: self.dragEnd_handler
      // }).setTracking(true);

      //this.overlay.paperCanvas().add(circle);
      //paper.project.activeLayer.addChild(circle);
    },
    onMouseDown(event) {
      // in order to access functions in nested tool

      let self = this

      // create drawing tool
      //this.tool = this.createTool(paper);
      // this.tool.onMouseDown = (event) => {
      // 	// init path
      // 	self.path = self.pathCreate(self.scope);
      // 	// add point to path
      // 	self.path.add(event.point);
      // };
      // this.tool.onMouseDrag = (event) => {
      // 	self.path.add(event);
      // };
      // this.tool.onMouseUp = (event) => {
      // 	// line completed
      // 	self.path.add(event.point);
      // };

      self.segment = self.path = null
      var transformed_point = paper.view.viewToProject(
        new paper.Point(event.position.x, event.position.y)
      )
      console.log('point ', transformed_point)
      var hitResult = paper.project.hitTest(transformed_point, self.hitOptions)
      //       hit_item = null;
      // var transformed_point = paper.view.viewToProject(new paper.Point(event.position.x, event.position.y));
      // var hit_test_result = paper.project.hitTest(transformed_point);
      // if (hit_test_result) {
      // 	hit_item = hit_test_result.item;
      // }

      // remove selection
      if (self.lastSelected && self.lastSelected !== event.item) {
        console.log('last: ', self.lastSelected)
        self.lastSelected.selected = false
        self.onDeselect()
      }
      console.log('HIT RESULT: ', hitResult)
      if (!hitResult) {
        return
      }
      console.log('event: ', event)
      if (event.originalEvent.shiftKey) {
        if (hitResult.type == 'segment') {
          hitResult.segment.remove()
        }
      }

      if (hitResult) {
        this.viewer.setMouseNavEnabled(false)

        hitResult.item.selected = true
        self.lastSelected = hitResult.item
        self.onSelect(self.lastSelected)

        console.log('last: ', self.lastSelected)
        self.path = hitResult.item
        if (hitResult.type == 'segment') {
          if (event.originalEvent.shiftKey) {
            hitResult.segment.remove()
            return
          }
          self.segment = hitResult.segment
        } else if (hitResult.type == 'stroke') {
          var location = hitResult.location
          console.log('hitResult location ', hitResult.location)

          self.segment = self.path.insert(location.index + 1, transformed_point)
          //self.path.smooth();
        }
      }
      if (hitResult.type == 'fill') {
        self.movePath = true
      } else {
        self.movePath = false
      }
      if (self.movePath) paper.project.activeLayer.addChild(hitResult.item)

      console.log('movePath', self.movePath)
    },

    doDrag(event) {
      console.log('DRAGGING...')
      let self = this
      var transformed_point1 = paper.view.viewToProject(new paper.Point(0, 0))
      var transformed_point2 = paper.view.viewToProject(
        new paper.Point(event.delta.x, event.delta.y)
      )
      console.log('segment ', self.segment)
      console.log('path ', self.path)
      if (self.segment) {
        //self.segment.point += event.delta;
        // self.segment.point = new paper.Point(
        // 	self.segment.point.x + event.delta.x,
        // 	self.segment.point.y + event.delta.y
        // );

        self.segment.point = self.segment.point.add(
          transformed_point2.subtract(transformed_point1)
        )
        console.log('segment point', self.segment.point)
        this.viewer.setMouseNavEnabled(false)

        paper.view.draw()
        //path.smooth();
      } else if (self.path) {
        //self.path.position += event.delta;
        // self.path.position = new paper.Point(
        // 	self.path.position.x + event.delta.x,
        // 	self.path.position.y + event.delta.y

        self.path.position = self.path.position.add(
          transformed_point2.subtract(transformed_point1)
        )
        this.viewer.setMouseNavEnabled(false)

        paper.view.draw()
      }
    },

    onKeyUp(event) {
      let self = this

      console.log('KEY UP ', event)

      // When a key is released, set the content of the text item:
      //text.content = 'The ' + event.key + ' key was released!';
      if (event.originalEvent.key === 'c') {
        self.createPaths()
      }

      if (event.originalEvent.key === 'd') {
        self.lastSelected.selected = false
        self.lastSelected.remove()
        self.lastSelected = null
      }
    },

    createPaths() {
      var radiusDelta = this.values.maxRadius - this.values.minRadius
      var pointsDelta = this.values.maxPoints - this.values.minPoints
      for (var i = 0; i < this.values.paths; i++) {
        var radius = this.values.minRadius + Math.random() * radiusDelta
        var points =
          this.values.minPoints + Math.floor(Math.random() * pointsDelta)

        var x = paper.view.size._width * 0.5
        console.log('X: ', paper.view.size._width, paper.Point.random().x)

        var y = paper.view.size._height * 0.5

        console.log('Y: ', paper.view.size._height, paper.Point.random().y)

        var center = new paper.Point(x, y)
        //center = paper.Point()(paper.view.size * paper.Point.random());
        console.log('CENTER ', center)
        this.path = this.createBlob(paper.view.center, radius, points)
        var lightness = (Math.random() - 0.5) * 0.4 + 0.4
        var hue = Math.random() * 360
        this.path.fillColor = {
          hue: 0,
          saturation: 1,
          lightness: 1,
          alpha: 0.5
        }
        // this.path.selectedColor = {
        //   hue: 180,
        //   saturation: 1,
        //   lightness: 0.5,
        //   alpha: 0.5
        // }
        this.path.strokeColor = 'white'
        this.path.strokeWidth = 3
      }
    },

    createBlob(center, maxRadius, points) {
      console.log('center param in CreateBlob ', center)
      var rectangle = new paper.Rectangle(center, maxRadius)
      var path = new paper.Path.Rectangle(rectangle)
      path.closed = true
      // for (var i = 0; i < points; i++) {
      //   console.log('POINTS FOR ', i, points)
      //   var delta = new paper.Point({
      //     length: maxRadius,
      //     //angle: (360 / points) * i
      //     angle: 90 + 90 *i
      //   })
      //   path.add(new paper.Point(center.x + delta.x, center.y + delta.y))
      // }
      //path.smooth();
      //path.flatten(4);
      path.data = Object.assign(path.data, { linkedRecord: {} })

      console.log(path)
      return path
    },

    changeZoom(oldZoom, delta) {
      var factor = 1.05
      if (delta < 0) {
        return oldZoom * factor
      }

      if (delta > 0) {
        return oldZoom / factor
      }
    },

    changeCenter(oldCenter, deltaX, deltaY, factor) {
      var offset = new paper.Point(deltaX, -deltaY)
      offset = offset.multiply(factor)
      oldCenter.add(offset)
    },

    dragEndHandler(event) {
      this.viewer.setMouseNavEnabled(true)
      //this.hitResult = null;
    },
    importFromJSON(data) {
      if (data) {
        paper.project.clear()
        paper.project.activeLayer.selected = false
        paper.project.importJSON(data)
      }
    },
    exportToJSON() {
      paper.project.activeLayer.selected = false
      console.log('export')
      return paper.project.exportJSON({ asString: false })
    },

    getSelectedPolygon() {
      console.log('REQUESTED LAST: ', this.lastSelected)
      return this.lastSelected
    },

    onSelect(path) {
      this.$emit('selected', path)
    },

    onDeselect() {
      this.$emit('deselected')
    }

    // resolve: function(object, key) {
    //   try {
    //     const _keys = key.split('.')
    //     let _cursor = object
    //     for (const _key of _keys) {
    //       _cursor = _cursor[_key]
    //     }
    //     return _cursor
    //   } catch (e) {
    //     return null
    //   }
    // },

    /**
     @see https://openseadragon.github.io/examples/ui-customize-tooltips/
     */
    // translate: function() {
    //   if (!this.i18n || !this.messages) {
    //     return
    //   }
    //
    //   const _messages = this.i18n.messages[this.i18n.locale]
    //   for (const label in this.messages) {
    //     OpenSeadragon.setString(
    //       label,
    //       this.resolve(_messages, this.messages[label])
    //     )
    //   }
    // }
  }
}
</script>

<style scoped></style>
